import { gql } from "@apollo/client"
import {
    BasePartnershipTierSelectorItemApplylistFragment,
    BasePartnershipTierSelectorItemTierFragment,
} from "../Base/fragment"

export const NewPartnershipTierSelectorItemTierFragment = gql`
    fragment NewPartnershipTierSelectorItemTierFragment on CollectivePassType {
        id
        ...BasePartnershipTierSelectorItemTierFragment
    }
    ${BasePartnershipTierSelectorItemTierFragment}
`

export const NewPartnershipTierSelectorItemApplylistFragment = gql`
    fragment NewPartnershipTierSelectorItemApplylistFragment on ApplylistType {
        id
        slug
        canEdit
        customHireLink
        group {
            id
        }
        ...BasePartnershipTierSelectorItemApplylistFragment
    }
    ${BasePartnershipTierSelectorItemApplylistFragment}
`
